import {
  ASSISTANT_LOADING,
  ASSISTANT_ERROR,
  SET_ASSISTANT,
  SET_ASSISTANTS,
  ASSISTANTS_LOADING,
  SET_ACTIVE_ASSISTANT,
} from "../actions/type";
import { ACTIVE_ASSISTANT_KEY } from "../actions/assistants";

// Built fresh on every initialisation rather than captured once at module
// load. DESTROY_SESSION resets the store to undefined, so a snapshot taken at
// load would restore the *previous* account's activeId after logout - and the
// next user would fetch an assistant that is not theirs.
const initialState = () => ({
  // The assistant created during onboarding; later steps read from here.
  current: null,
  // Everything GET /assistants returns, for the sidebar switcher.
  list: [],
  // Which assistant the app is pointed at, rehydrated so a refresh keeps it.
  activeId: localStorage.getItem(ACTIVE_ASSISTANT_KEY) || "",
  loading: false,
  // GET /assistants specifically, so the switcher can tell a list it is still
  // waiting on from one it has.
  listLoading: false,
  error: "",
});

export default function assistantsReducer(state, action) {
  if (state === undefined) state = initialState();

  const { type, payload } = action;

  switch (type) {
    case SET_ASSISTANT:
      return {
        ...state,
        current: payload,
      };
    case SET_ASSISTANTS:
      return {
        ...state,
        list: payload,
      };
    case ASSISTANTS_LOADING:
      return {
        ...state,
        listLoading: payload,
      };
    case SET_ACTIVE_ASSISTANT:
      return {
        ...state,
        activeId: payload,
      };
    case ASSISTANT_LOADING:
      return {
        ...state,
        loading: payload,
      };
    case ASSISTANT_ERROR:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
}
